import '../../sass/blocks/hero-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $heroCarousels = document.querySelectorAll('.hero-carousel');

    if (!$heroCarousels) return;

    $heroCarousels.forEach($heroCarousel => {
        const $imagesCarousel = $heroCarousel.querySelector('.hero-carousel__images');
        const $contentCarousel = $heroCarousel.querySelector('.hero-carousel__content');
        const $pagination = $heroCarousel.querySelector('.hero-carousel__pagination');

        const initCarousels = () => {
            if (!$imagesCarousel || !$contentCarousel) return;

            const imagesCarousel = new Swiper($imagesCarousel, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
                loop: true,
            });

            const contentCarousel = new Swiper($contentCarousel, {
                watchSlidesProgress: true,
                autoplay: {
                    delay: 5000,
                },
                speed: 500,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                controller: {
                    control: imagesCarousel
                },
                loop: true,
                pagination: {
                    el: $pagination,
                    clickable: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });
        };

        initCarousels();
    });
})();
